import { Paper, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { CustomFile } from 'components';
import skeletonBg from 'utils/bg-images/skeletonBg.png';

const BoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '1080px',
  height: '500px',
  background: `url(${skeletonBg})`,
  boxSizing: 'border-box',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat'
};

const LogoImageWrapper = (url: any) => {
  const LogoImage = styled(Paper)(() => ({
    flex: 1,
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    height: '52px',
    width: '32.5%',
    background: `url(${url.url})`,
    boxSizing: 'border-box',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    marginTop: '2px'
  }));
  return <LogoImage id={'logo'} />;
};

const BgImageWrapper = (url: any) => {
  const BgImage = styled(Paper)(() => ({
    background: `url(${url.url})`,
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    borderRadius: '0',
    height: '266px',
    marginLeft: '252px',
    marginTop: '26px',
    width: '550px',
    textAlign: 'center'
  }));
  return <BgImage />;
};

export interface IImagePreview {
  show: boolean;
  onClose: () => void;
  files: ICurrentPreviewImages;
}

export interface ICurrentPreviewImages {
  logo: CustomFile;
  bg: CustomFile;
}

export default function UploadImagePreview(props: IImagePreview) {
  return (
    <div>
      <Modal
        open={props.show}
        onClose={props.onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={BoxStyle}>
          <LogoImageWrapper
            url={props?.files?.logo?.preview}
            sx={{ width: '370px', height: '60px' }}
          />
          <BgImageWrapper url={props?.files?.bg?.preview} />
        </Box>
      </Modal>
    </div>
  );
}
